export const TUTORIAL_STATUS_OPTIONS = [
  {
    value: "all",
    label: "Tous les statuts",
  },
  {
    value: "publie",
    label: "Publiés",
  },
  {
    value: "brouillon",
    label: "Brouillons",
  },
  {
    value: "archive",
    label: "Archivés",
  },
];

export const TUTORIAL_SCOPE_OPTIONS = [
  {
    value: "all",
    label: "Toutes les portées",
  },
  {
    value: "global",
    label: "Tutoriels globaux",
  },
  {
    value: "site",
    label: "Tutoriels spécifiques",
  },
];

export const TUTORIAL_SORT_OPTIONS = [
  {
    value: "updated_desc",
    label: "Dernière modification",
  },
  {
    value: "version_desc",
    label: "Version décroissante",
  },
  {
    value: "version_asc",
    label: "Version croissante",
  },
  {
    value: "title_asc",
    label: "Titre A → Z",
  },
  {
    value: "title_desc",
    label: "Titre Z → A",
  },
];

export const INITIAL_TUTORIAL_FORM = {
  app_key: "monappli-club",
  site_key: "",
  locale: "fr-FR",
  version: 1,

  titre: "Tutoriel • MonAppliClub",
  sous_titre:
    "Guide pas à pas pour bien débuter et tout retrouver facilement.",

  intro_label: "Bienvenue",
  intro_titre: "Bienvenue sur MonAppliClub",
  intro_contenu: "",

  faq_label: "Questions fréquentes",
  faq_titre: "Questions fréquentes",

  afficher_feedback: true,
  feedback_question: "Ce tutoriel vous a-t-il aidé ?",
  feedback_description:
    "Vos retours nous aident à améliorer l’application.",

  support_titre: "Besoin d’aide ?",
  support_description:
    "Contactez le développeur Web : Laurent VICTORIN.",
  support_nom: "Laurent VICTORIN",
  support_email: "monappliclub@gmail.com",
  support_telephone: "06 80 72 77 07",

  is_active: true,
};

export const TUTORIAL_CONTENT_FORMAT_OPTIONS = [
  {
    value: "texte",
    label: "Texte simple",
  },
  {
    value: "markdown",
    label: "Markdown",
  },
  {
    value: "html",
    label: "HTML nettoyé",
  },
];

export const TUTORIAL_MEDIA_TYPE_OPTIONS = [
  {
    value: "image",
    label: "Image",
  },
  {
    value: "youtube",
    label: "Vidéo YouTube",
  },
  {
    value: "video",
    label: "Fichier vidéo",
  },
  {
    value: "pdf",
    label: "Document PDF",
  },
  {
    value: "lien",
    label: "Lien externe",
  },
];